module.exports = __webpack_public_path__ + "static/the-war-of-art-1fe9d1a47acd3c6655fbb609e2427a53.jpg";